<template>
  <v-btn color="indigo" dark="" class="mr-2" @click="makeEvaluationExcel()">
    Excel
    <v-icon right>mdi-microsoft-excel</v-icon>
  </v-btn>
</template>

<script>
import XLSX from 'sheetjs-style';

export default {
  name: 'WorkingHoursEvaluationExcelExport',
  props: {
    excel_data: {
      type: Array
    },
    name: {
      type: String
    },
    year: {
      type: [Number, String]
    }
  },
  methods: {
    makeEvaluationExcel() {
      let ExcelName = 'Arbeitsstunden Auswertung Soll-Ist ' + (this.year || '');
      ExcelName = ExcelName.trim();
      var wb = XLSX.utils.book_new();

      var Data = [];
      this.excel_data.forEach(e => {
        Data.push({
          'Mitgliedsnummer': e.mitgliedsnummer,
          'Nachname': e.name,
          'Vorname': e.vorname,
          'Beitragsgruppe': e.beitragsgruppe ? e.beitragsgruppe.name : '',
          'Soll Stunden': e.soll_stunden,
          'Ist Stunden': e.ist_stunden,
          'Differenz': e.differenz,
          'Status': e.erfuellt ? 'Erfüllt' : 'Offen',
          'Anzahl Einträge': e.anzahl_eintraege
        });
      });

      var evaluationWS = XLSX.utils.json_to_sheet(Data);

      const CellOptions = {
        font: {
          name: 'Arial',
          sz: 10,
          bold: true,
          color: {rgb: "FFFFFFFF"}
        },
        fill: {
          bgColor: {rgb: "FF59AB44"},
          fgColor: {rgb: "FF59AB44"},
        },
        alignment: {
          wrapText: true
        },
      };

      if (evaluationWS['!ref']) {
        var range = XLSX.utils.decode_range(evaluationWS['!ref']);
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var cell_Header_Address = {c: C, r: 0};
          var cell_ref = XLSX.utils.encode_cell(cell_Header_Address);
          if (evaluationWS[cell_ref]) {
            evaluationWS[cell_ref].s = CellOptions;
          }
        }
      }

      XLSX.utils.book_append_sheet(wb, evaluationWS, 'Auswertung');
      XLSX.writeFile(wb, ExcelName + '.xlsx');
    }
  },
}
</script>
